// START GENAI
/* Default theme (dark) */
vs-adlibs {
  --text-color: #fff;
  --font-family: "Visa Dialect", sans-serif;
  --heading-size-desktop: 16px;
  --heading-size-mobile: 14px;
  --heading-size-xs: 12px;
  --text-size-desktop: 52px;
  --text-size-mobile: 32px;
  --text-size-xs: 32px;
  --button-text-size: 14px;
  --button-text-size-xs: 12px;
  --button-radius: 1000px;
  --spacing-m: 48px;
  --spacing-xs: 24px;
  --dropdown-border-color: rgba(255, 255, 255, 0.3);
  --font-family: "Visa Dialect", sans-serif;
  display: block;
  font-family: var(--font-family);
  box-sizing: border-box;
  --button-secondary-bg: transparent;
  --button-secondary-border: #ffffff;
  --button-secondary-text: #ffffff;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #ffffff;
  --button-secondary-border: #ffffff;
}

.vs-adlib-theme-light {
  --primary-bg: #ffffff;
  --text-bottom-panel-color: #1a1a1a;
  --text-color: #1a1a1a;
  --dropdown-border-color: rgba(0, 0, 0, 0.3);
  --color-text-inverse: #ffffff;
  --button-secondary-bg: transparent;
  --button-secondary-text: #1a1a1a;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #f0f0f0;
  --button-secondary-border: #1a1a1a;
}

.vs-adlib-theme-dark {
  --primary-bg: #1a1a1a;
  --text-color: #ffffff;
  --text-bottom-panel-color: #ffffff;
  --color-text-inverse: #ffffff;
  --button-secondary-bg: transparent;
  --button-secondary-text: #ffffff;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #ffffff;
  --button-secondary-border: #ffffff;
}

.vs-adlib-container[style*="--adlib-bg-desktop"] {
  --primary-bg: #ffffff;
  --text-color: #ffffff;
  --text-bottom-panel-color: #1a1a1a;
  --dropdown-border-color: rgba(255, 255, 255, 0.3);
  --button-secondary-bg: transparent;
  --button-secondary-text: #ffffff;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #ffffff;
  --button-secondary-border: #ffffff;
}

.vs-adlib-container[style*="--adlib-bg-mobile"] {
  --primary-bg: #ffffff;
  --text-color: #ffffff;
  --text-bottom-panel-color: #1a1a1a;
  --dropdown-border-color: rgba(255, 255, 255, 0.3);
  --button-secondary-bg: transparent;
  --button-secondary-text: #ffffff;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #ffffff;
  --button-secondary-border: #ffffff;
}

.vs-adlib-container {
  position: relative;
  width: 100%;
  height: 800px;
  overflow: hidden;
  background-image: var(--adlib-bg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--primary-bg);
  color: var(--text-color);
}

.vs-adlib-video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
}

.vs-adlib-video-container vsr-video {
  width: 100%;
  height: 100%;
}

@media (max-width: 480px) {
  .vs-adlib-container {
    --adlib-bg: var(--adlib-bg-mobile);
    width: 100%;
    height: 800px;
  }
}

.vs-adlib-container-wrapper {
  padding: 40px 48px;
  position: relative;
  z-index: 1;
}
.vs-adlib-heading {
  font-size: var(--heading-size-desktop);
  font-weight: 500;
  line-height: 1.5;
  color: var(--button-secondary-text);
  margin: 0;
}
.vs-adlib-selection-container {
  display: flex;
  flex-direction: column;
  margin-top: 225px;
}
.vs-adlib-selection-row {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.vs-adlib-selection-row:first-child {
  margin-bottom: 16px;
}

@media (max-width: 576px) {
  .vs-adlib-selection-row:first-child {
    margin-bottom: 0;
  }
}

@media (max-width: 504px) {
  /* Move connector text to appear with card types */
  .vs-adlib-connector {
    display: none; /* Hide from original position */
  }

  /* Create a pseudo-element to display the connector text after the card type */
  .vs-adlib-selection-row:first-child::after {
    content: attr(data-connector);
    display: inline-block;
    font-size: var(--text-size-xs);
    font-weight: 400;
    letter-spacing: -0.01em;
    line-height: 1.2;
    white-space: nowrap;
    margin-left: 11px; /* Specific 16px spacing between dropdown icon and connector */
    order: 3; /* Ensure it appears after the dropdown */
  }

  /* Make the first row use flexbox to properly position elements */
  .vs-adlib-selection-row:first-child {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
  }

  /* Adjust spacing for the second row when it's visible */
  .vs-adlib-selection-row:nth-child(2) {
    margin-top: 8px;
  }
}

/* Special alignment for screens between 474px and 504px */
@media (min-width: 474px) and (max-width: 504px) {
  /* Adjust the connector text alignment to match with travel benefits dropdown */
  .vs-adlib-selection-row:first-child::after {
    vertical-align: baseline;
    margin-top: 0;
    margin-left: 8px; /* Fine-tune spacing to align with dropdown text */
  }
}
.vs-adlib-selection-text {
  font-size: var(--text-size-desktop);
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 1.2;
  white-space: nowrap;
}
.vs-adlib-with-text {
  text-align: center;
}
.vs-adlib-dropdown-container {
  position: relative;
}

.vs-adlib-dropdown-container {
  display: inline-flex; // ensures icon moves within container
  &:hover {
    .vs-adlib-dropdown-content {
      color: #b0b7d8;
      border-color: #b0b7d8;
    }
    .vs-adlib-dropdown-icon {
      .vs-adlib-arrow-down {
        top: 2px;
      }
      color: #b0b7d8;
    }
  }
}

.vs-adlib-dropdown {
  display: flex;
  align-items: baseline;
  cursor: default;
  padding-bottom: 0.5rem;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  text-align: left;
  width: 100%;
  border-bottom: none;

  &:focus {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}
.vs-adlib-dropdown-content {
  font-size: var(--text-size-desktop);
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -0.01em;
  margin-right: 0.5rem;
  display: inline-block;
  border-bottom: 1px solid var(--text-color);
}
.vs-adlib-dropdown-icon {
  display: flex;
  align-items: baseline;
  margin-top: 0.5rem;
  transition:
    margin-top 0.3s ease,
    color 0.3s ease; // smooth transition
}

.vs-adlib-arrow-down {
  display: inline-block;
  width: 20px;
  height: 20px;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: translate(-50%, -75%) rotate(45deg);
  }
}
.vs-adlib-bottom-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--primary-bg);
  padding: 2rem;
  z-index: 9999;
  width: 100%;
  box-sizing: border-box;
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 0.3s ease-in-out;
  visibility: hidden;
  pointer-events: none;

  &.show {
    transform: scaleY(1);
    visibility: visible;
    pointer-events: auto;
  }
}

body.no-scroll {
  overflow: hidden;
  height: 100%;
}

.vs-adlib-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #00000080;
  z-index: 9998;
  opacity: 1;
  inset: 0;
}

.vs-adlib-panel-content {
  display: flex;
  margin-bottom: 2rem;
  @media (max-width: 480px) {
    height: auto;
  }
}

.vs-adlib-panel-left {
  flex: 1;
  @media (max-width: 480px) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.vs-adlib-panel-right {
  flex: 1;
  position: relative;
}

.vs-adlib-panel-divider {
  position: absolute;
  left: -1rem;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #e0e0e0;
}

.vs-adlib-panel-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
  @media (max-width: 480px) {
    padding-top: 0;
    justify-content: start;
  }
}

.vs-adlib-panel-name {
  font-size: 32px;
  font-weight: 400;
  line-height: 1.25;
  color: var(--text-bottom-panel-color);
  @media (max-width: 480px) {
    margin-top: 0;
  }
}

.vs-adlib-card-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.vs-adlib-card-item {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.01em;
  color: var(--text-bottom-panel-color);
  padding: 0.5rem 0;
  cursor: pointer;

  &:hover {
    transition: all 0.2s ease;
    margin-left: 4px;
    color: #d9d9d9;
    text-decoration: none;
  }
}

.vs-adlib-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
}

.vs-adlib-close-icon {
  position: relative;
  width: 20px;
  height: 20px;

  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--text-bottom-panel-color);
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
}

.vs-adlib-see-all-link {
  display: flex;
  align-items: center;
  color: var(--text-bottom-panel-color);
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
  gap: 0.5rem;
  transition:
    gap 0.2s,
    color 0.2s;

  &:hover {
    color: #8f9fe4;
    text-decoration: none;
    gap: 1rem;
    .vs-adlib-arrow-right {
      color: #8f9fe4;
    }
  }
}

.vs-adlib-button-container {
  display: flex;
  gap: 1rem;
  margin-top: 0rem;
  height: 48px;
  margin-top: 32px;
  @media (max-width: 480px) {
    flex-direction: column;
  }
}
.vs-adlib-action-button {
  background: transparent;
  border: 1px solid var(--button-secondary-border);
  border-radius: var(--button-radius);
  color: var(--button-secondary-text);
  font-family: var(--font-family);
  font-size: var(--button-text-size);
  font-weight: 400;
  font-style: normal;
  line-height: 140%;
  letter-spacing: 0%;
  text-align: center;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: background-color 0.2s ease;
  text-decoration: none;
  &:hover,
  &:focus-visible {
    outline: none;
    background-color: var(--button-secondary-bg-hover);
    color: var(--button-secondary-hover-text);
    text-decoration: none;
  }
}

.vs-adlib-theme-light {
  .vs-adlib-action-button {
    border: 1px solid var(--button-secondary-border);
  }
}

.vs-adlib-results-button {
  background-color: transparent;
}

.vs-adlib-match-button {
  background-color: transparent;
}

.vs-adlib-theme-light .vs-adlib-action-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.vs-adlib-sparkle-icon,
.vs-adlib-arrow-icon {
  width: 16px;
  height: 16px;
}
.vs-adlib-browse-link {
  color: var(--text-color);
  text-decoration: none;
  font-size: var(--button-text-size);
  display: flex;
  align-items: center;
  width: fit-content;
  margin-top: 215px;
  gap: 0.5rem;
  transition:
    gap 0.2s,
    color 0.2s;

  &:hover {
    color: #8f9fe4;
    text-decoration: none;
    gap: 1rem;
    .vs-adlib-arrow-right {
      color: #8f9fe4;
    }
  }
}

.vs-adlib-arrow-right {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 3px;
    width: 8px;
    height: 8px;
    border-top: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: translateY(-50%) rotate(45deg);
  }

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 12px;
    height: 2px;
    background-color: currentColor;
    transform: translateY(-50%);
  }
}

.vs-adlib-arrow-icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}
@media (max-width: 1024px) {
  .vs-adlib-container {
    width: 100%;
    height: 560px;
  }
  .vs-adlib-heading {
    font-size: var(--heading-size-mobile);
  }

  .vs-adlib-selection-container {
    margin-top: 114px;
  }

  .vs-adlib-selection-text,
  .vs-adlib-dropdown-content,
  .vs-adlib-dropdown-content .vs-adlib-dropdown-button {
    font-size: var(--text-size-mobile);
  }

  .vs-adlib-selection-row {
    width: 100%;
    flex-wrap: wrap;
  }

  .vs-adlib-dropdown-container {
    position: relative;
    display: inline-block;
  }

  .vs-adlib-browse-link {
    margin-top: 90px;
  }
}

@media (max-width: 768px) {
  .vs-adlib-container-wrapper {
    padding: 40px 24px;
  }
}

/* XS mobile variation */
@media (max-width: 480px) {
  .vs-adlib-container {
    --adlib-bg: var(--adlib-bg-mobile) !important;
    width: 100%;
    height: 800px;
  }
  .vs-adlib-container-wrapper {
    padding: 32px 24px;
  }
  .vs-adlib-selection-container {
    margin-top: 80px;
  }

  .vs-adlib-heading {
    font-size: var(--heading-size-xs);
  }

  .vs-adlib-selection-text,
  .vs-adlib-dropdown-content {
    font-size: var(--text-size-xs);
  }

  .vs-adlib-dropdown {
    padding-bottom: 0.25rem;
  }

  .vs-adlib-dropdown-icon {
    margin-top: 0.25rem;
  }

  .vs-adlib-arrow-down {
    width: 16px;
    height: 16px;
  }

  .vs-adlib-arrow-down:before {
    width: 8px;
    height: 8px;
  }

  .vs-adlib-button-container {
    gap: 0.5rem;
  }

  .vs-adlib-action-button {
    font-size: var(--button-text-size-xs);
  }

  .vs-adlib-browse-link {
    font-size: var(--button-text-size-xs);
    margin-top: 32px;
  }

  .vs-adlib-bottom-panel {
    padding: 1.5rem;
  }

  .vs-adlib-panel-name {
    font-size: 24px;
  }

  .vs-adlib-card-item {
    font-size: 14px;
    padding: 0.4rem 0;
  }

  /* Improve selection row layout for XS screens */
  .vs-adlib-selection-row {
    margin-bottom: 0rem;
    gap: 0.3rem;
  }

  /* Ensure text doesn't overflow on very small screens */
  .vs-adlib-selection-text {
    white-space: normal;
    line-height: 1.1;
  }

  /* Make panel more compact for XS screens */
  .vs-adlib-panel-content {
    flex-direction: column;
    margin-bottom: 1rem;
  }

  .vs-adlib-panel-left {
    margin-bottom: 1rem;
    border-bottom: 1px solid var(--text-color);
  }

  .vs-adlib-panel-right {
    flex: 1;
  }

  .vs-adlib-panel-divider {
    display: none;
  }

  /* Adjust see all link for XS screens */
  .vs-adlib-see-all-link {
    font-size: 12px;
  }
}
